<template>
  <v-container fluid class="px-0 mx-0 pt-7">
    <v-row
      no-gutters
      :class="{ 'flex-sm-row flex-column': mobileBreakpoint, 'mb-3': actions }"
    >
      <v-col
        class="d-flex mr-2"
        :class="{ 'justify-center justify-sm-start': mobileBreakpoint }"
      >
        <v-btn v-if="backButton" @click="$router.go(-1)" icon>
          <v-icon color="black">mdi-arrow-left</v-icon>
        </v-btn>

        <h1 class="app-body-subtitle-text mr-2">{{ subtitle }}</h1>

        <v-tooltip v-if="info" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
          </template>
          <span>{{ infoMessage }}</span>
        </v-tooltip>
      </v-col>

      <v-col
        v-if="actions.length > 0"
        class="d-flex justify-end align-center"
        :class="{ 'justify-center justify-sm-end mt-2': mobileBreakpoint }"
      >
        <template v-for="(act, index) in actions">
          <v-menu
            :key="index"
            v-if="Array.isArray(act)"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="rounded-xxl"
                v-bind="attrs"
                v-on="on"
                :loading="primaryLoading"
                :class="index === 0 ? 'button' : 'button btn-right'"
              >
                {{ menuTitle }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(subAct, subIndex) in act"
                :key="subIndex"
                @click="subAct.action()"
              >
                <v-list-item-title>{{ subAct.name }}</v-list-item-title>
                <v-list-item-icon>
                  <v-icon>{{ subAct.icon }}</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            class="rounded-xxl"
            v-else
            :key="index"
            @click="act.action()"
            :class="
              act.outlined
                ? 'button-outlined elevation-0'
                : index == 0
                ? 'button'
                : 'button btn-right'
            "
            :loading="
              act.id === 'CSV'
                ? primaryLoading
                : act.id === 'PDF'
                ? secondaryLoading
                : thertiaryLoading
            "
            :disabled="act.id == 'NEW' ? disableActions : false"
          >
            <v-icon v-if="act.iconLeft" class="mr-2">
              {{ act.iconLeft }}
            </v-icon>
            {{ act.name }}
            <v-icon v-if="act.icon" :class="act.name && 'ml-2'">
              {{ act.icon }}
            </v-icon>
          </v-btn>
        </template>
      </v-col>
    </v-row>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: "app-body",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: [String, Function],
      default: "",
    },
    info: {
      type: Boolean,
      default: false,
    },
    infoMessage: {
      type: String,
      default: "Message here",
    },
    actions: {
      type: Array,
      default: () => [],
    },
    primaryLoading: {
      type: Boolean,
      default: false,
    },
    secondaryLoading: {
      type: Boolean,
      default: false,
    },
    thertiaryLoading: {
      type: Boolean,
      default: false,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    mobileBreakpoint: {
      type: Boolean,
      default: false,
    },
    menuTitle: {
      type: String,
      default: "Menu",
    },
  },
};
</script>

<style scoped>
.app-body-subtitle-text {
  font-size: 1em;
  align-self: center;
}

.button-outlined {
  background: #e9e8ed;
  border: 2px solid #7513bf;
  color: #7513bf;
}
</style>
